import { PureComponent, PropsWithChildren } from "react";

export default class SpellsFilterAdvancedFilter extends PureComponent<PropsWithChildren> {
  render() {
    return (
      <div className="ct-spells-filter__adv-filter">{this.props.children}</div>
    );
  }
}
